import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

// 상단바안에 부분 Link to 사용해서 route연결

function Header() {

  /** 드롭다운 안에 들어가는 버튼*/
  function slideMenu() {
    $(".main-header .navigation li.dropdown .dropdown-btn")
      .prev("ul")
      .off()
      .slideToggle(500);
  }

  /**Disable dropdown parent link */
  $(
    ".main-header .navigation li.dropdown > a,.hidden-bar .side-menu li.dropdown > a"
  ).on("click", function (e) {
    e.preventDefault();
  });

  /** 이벤트 발생시 스크롤을 최상단으로 올리는 핸들러 */
  function scrollUpHandler(){
    $('html').scrollTop(0)
  }

  return (
    <header className="main-header header-style-one">
      <div className="header-lower">
        <div className="main-box">
          <div className="auto-container">
            <div className="outer-container clearfix">
              <div className="logo-box">
                <div className="logo">
                  <Link to="/" title="The Finance">
                    <img src="/images/home/logo.png" alt="" />
                  </Link>
                </div>
              </div>

              <div className="nav-outer clearfix">
                <nav className="main-menu">
                  <div className="navbar-header">
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-toggle="collapse"
                      data-target=".collapse"
                    >
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>

                  <div className="navbar-collapse clearfix collapse">
                    <ul className="navigation clearfix">
                      <li className="dropdown">
                        <Link to="/ai">Ai&Big Data</Link>

                        <ul>
                          <li>
                            <Link to="/ai">AI관제 서비스</Link>
                          </li>
                          <li>
                            <Link to="/bigdata">빅데이터 플랫폼</Link>
                          </li>
                          <li>
                            <Link to="/fusion">빅데이터 융합서비스</Link>
                          </li>
                          {/* <li>
                            <Link to="/tmap">T-map API</Link>
                          </li> */}
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link to="smartcity">스마트 서비스</Link>
                        <ul>
                          <li>
                            <Link to="smartcity">스마트 시티서비스</Link>
                          </li>
                          <li>
                            <Link to="safe">안전플랫폼</Link>
                          </li>
                          <li>
                            <Link to="sims">SIMS</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link to="smartfactory">스마트 팩토리</Link>
                        {/* <ul>
                          <li>
                            <Link to="smartfactory">스마트팩토리</Link>
                          </li>
                        </ul> */}
                      </li>
                      <li className="dropdown">
                        <Link to="#">회사소개</Link>
                        <ul>
                          <li>
                            <Link to="about">넥스모어시스템즈</Link>
                          </li>
                          <li>
                            <Link to="history">주요연혁</Link>
                          </li>
                          <li>
                            <Link to="org">조직도</Link>
                          </li>
                          <li>
                            <Link to="partner">파트너</Link>
                          </li>
                          <li>
                            <Link to="recruit">인재채용</Link>
                          </li>
                          <li>
                            <Link to="map">오시는길</Link>
                          </li>
                        </ul>
                        <div className="dropdown-btn" onClick={slideMenu}>
                          <span className="fa fa-angle-down"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
            {/* <div class="absolute"><a href = ""><fontcolor = "white"> ENG</a></div> */}
            {/* <div class="absolute1"><a href = ""><fontcolor= "white"> KOR</a></div> */}
          </div>
        </div>
      </div>

      <div className="sticky-header">
        <div className="auto-container clearfix">
          <div className="logo pull-left">
            <Link to="/" title="consulted">
              <img src="images/home/logo2.png" alt=""  onClick={scrollUpHandler}/>
            </Link>
          </div>

          <div className="right-col pull-right">
            <nav className="main-menu">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              </div>
              <div className="navbar-collapse collapse clearfix">
                <ul className="navigation clearfix">
                  <li className="dropdown">
                    <Link to="#">Ai&Big Data</Link>
                    <ul>
                      <li>
                        <Link to="/ai" onClick={scrollUpHandler}>AI관제 서비스</Link>
                      </li>
                      <li>
                        <Link to="/bigdata" onClick={scrollUpHandler}>빅데이터 플랫폼</Link>
                      </li>
                      <li>
                        <Link to="/fusion" onClick={scrollUpHandler}>빅데이터 융합서비스</Link>
                      </li>
                      {/* <li>
                        <Link to="/tmap">T-map API</Link>
                      </li> */}
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link to="#">스마트 서비스</Link>
                    <ul>
                      <li>
                        <Link to="smartcity" onClick={scrollUpHandler}>스마트 시티서비스</Link>
                      </li>
                      <li>
                        <Link to="safe" onClick={scrollUpHandler}>안전플랫폼</Link>
                      </li>
                      <li>
                        <Link to="sims" onClick={scrollUpHandler}>SIMS</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link to="smartfactory" onClick={scrollUpHandler}>스마트 팩토리</Link>
                    {/* <ul>
                      <li>
                        <Link to="smartfactory">스마트팩토리</Link>
                      </li>
                    </ul> */}
                  </li>
                  <li className="dropdown">
                    <Link to="#">회사소개</Link>
                    <ul>
                      <li>
                        <Link to="about" onClick={scrollUpHandler}>넥스모어시스템즈</Link>
                      </li>
                      <li>
                        <Link to="history" onClick={scrollUpHandler}>주요연혁</Link>
                      </li>
                      <li>
                        <Link to="org" onClick={scrollUpHandler}>조직도</Link>
                      </li>
                      <li>
                        <Link to="partner" onClick={scrollUpHandler}>파트너</Link>
                      </li>
                      <li>
                        <Link to="recruit" onClick={scrollUpHandler}>인재채용</Link>
                      </li>
                      <li>
                        <Link to="map" onClick={scrollUpHandler}>오시는길</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>

            {/* <div class="absolute"><a href = "">< style="white">ENG</a></div> */}
            {/* <div class="absolute1"><a href = ""><fontcolr "black" >KOR</a></div> */}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
